/**
 * INSIGHT_MULTI_COLUMN_CHART_CONFIG: a JSON object representing a schema used to drive the chart
 * in the desktop view of the scenario analysis section.
 */
export const INSIGHT_MULTI_COLUMN_CHART_CONFIG = {
	chart: {
		height: 200,
		width: 170,
		style: {
			fontFamily: '"FortBook", Arial, sans-serif',
			color: '#616161'
		},
		type: 'column'
	},
	plotOptions: {
		column: {
			pointWidth: '30',
			groupPadding: 0.85,
			pointPadding: 0
		}
	},
	xAxis: {
		categories: [],
		title: { text: null },
		visible: false
	},
	yAxis: {
		categories: [],
		tickInterval: 2,
		tickAmount: 5,
		opposite: true,
		title: { text: null },
		labels: {
			x: -12,
			y: -5,
			formatter: function (): string {
				// apply % format to the first and last values of the yAxis while hiding the remainder of the values.
				if (this.isFirst || this.isLast) {
					if (parseInt(this.value, 10) !== 0) {
						return this.value + '%';
					} else {
						return this.value;
					}
				} else {
					this.value = '';
					return this.value;
				}
			}
		}
	},
	colors: [],
	extensibleData: null,
	series: [],
	tooltip: {
		enabled: false
	}
};
